/**
 * Opening balance as a trial-balance Debit / Credit pair.
 * @file src/web/features/admin/components/OpeningBalanceCell.tsx
 *
 * Laid out the way Tally's Trial Balance prints it: two money columns, an
 * amount in exactly one of them, and totals that must agree at the bottom.
 * A CA reads a chart of accounts by scanning those two columns, so one
 * combined "1,25,000 Dr" column made them do the sorting in their head.
 *
 * Underneath it stays ONE signed number in Tally sign — Dr negative, Cr
 * positive — because a ledger opens on one side or the other, never both.
 *
 * These cells only display. Changing a balance is done in the ledger's Edit
 * dialog, which owns the amount and its Dr/Cr side together.
 *
 * Renders TWO <td>s — use inside a <tr>, not wrapped in a cell.
 */

export function inr(n: number) {
  return Math.abs(n).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Read-only Debit/Credit pair — group subtotals and ledger rows alike. */
export function OpeningAmountCells({ value, bold, padding = 'px-5 py-2.5' }: {
  value: number | null;
  bold?: boolean;
  padding?: string;
}) {
  const v = value ?? 0;
  const cls = `${padding} text-right tabular-nums ${bold ? 'font-semibold text-ink-900' : 'text-ink-700'}`;
  return (
    <>
      <td className={cls}>{v < 0 ? inr(v) : ''}</td>
      <td className={cls}>{v > 0 ? inr(v) : ''}</td>
    </>
  );
}
